import classNames from 'classnames';
import type { ReactNode } from 'react';

import { ControlSize } from './ControlSize.ts';

type FormGroupProps = {
    children?: ReactNode;
    className?: string;
    size?: ControlSize;
    hasViolation?: boolean;
};

export const FormGroup = ({ children, className, size, hasViolation }: FormGroupProps) => {
    return (
        <div
            className={classNames('form-group', className, {
                'form-group-lg': size === ControlSize.LARGE,
                'has-error': hasViolation,
                'has-feedback': hasViolation,
            })}
        >
            {children}
        </div>
    );
};
